class QuickAdd {
    variantData = {};
    optionsData = {};

    selectedOptions = {};
    selectedVariantId = {};
    possibleOptions = [];

    currentPrice;
    salePrice;

    variantElements;
    formElement;
    submitElement;
    formOpen = false;

    formData;

    optionNamePrefix = "option";
    lastSelectedOptionKey;

    constructor(productId) {
        this.productId = productId;
        this.setupProductData();
        this.setupElementsAndDefaults();
        this.setupFilterDataAndSelectOptions();
        this.setupListeners();
        this.findAndSetInitialVariant();
        this.setupInitialVariantFound();
    }

    setupFilterDataAndSelectOptions() {
        this.filterData = false

        const filterDataElement = document.getElementById("collection-filters-data")

        if (filterDataElement) {
            const filterDataRaw = filterDataElement.textContent
            let filterData = this.jsonDecode(filterDataRaw)

            for (const filterLabel in filterData) {
                try {
                    const foundOption = this.optionsData.find((item, key) => {
                        return this.optionsData[key].name == filterLabel
                    })

                    filterData[filterLabel].position = foundOption.position
                    this.lastSelectedOptionKey = foundOption.position
                } catch (e) {
                    console.debug(e)
                }
            }

            this.filterData = filterData
            const filterOptionFound = this.setOptionsByFilterOptions()
            this.selectRadioButtonsForOptions()
            if (filterOptionFound) {
                this.hideAllOptionsExceptLast();
            }
            this.filteredVariants = this.getFilteredVariants()
            this.possibleOptions = this.getPossibleOptions();
            this.hideImpossibleOptions();
        }
    }

    // Compositional methods
    setupProductData() {
        this.variantData = this.getVariantData();
        this.optionsData = this.getOptionsData();
    }

    setupElementsAndDefaults() {
        this.formElement = document.getElementById(`${this.productId}-form`)

        // Important children of form element
        this.variantElements = this.formElement.querySelectorAll('input[type="radio"]')
        this.submitElement = this.formElement.querySelector("button.miir-quick-add-form__submit")
        this.cardElement = this.formElement.closest(".card")
        this.quantityElement = this.formElement.querySelector(".miir-quick-add-form__qty")
        this.personalizeContainer = this.formElement.querySelector(".cdp-button");

        // Important children of card element
        this.openElement = this.cardElement.querySelector(".quick-add-form-container__open")
        this.closeElement = this.cardElement.querySelector(".quick-add-form-container__close")
        this.quickAddParentElement = this.cardElement.querySelector(".quick-add-form-container")
        this.quickAddLink = this.cardElement.querySelector(".button--personalize")
        this.formParentEle = this.cardElement.querySelector(`.miir-quick-add-form`)

        this.originalDestination = this.getOriginalDestination();
        this.cartDrawer = document.querySelector("cart-drawer");
    }

    setupListeners() {
        this.attachOpenCloseListeners();
        this.attachRadioListeners();
        this.attachSubmitHandler();
    }

    setupInitialVariantFound() {
        let checkedInputs = this.formElement.querySelectorAll(
            'input[type="radio"]:checked'
        );

        checkedInputs.forEach(variantElement => {
            this.radioValueHandler(variantElement);
        });
    }

    // Retreiving data
    getVariantData() {
        let variantDataEl = document.getElementById(this.productId);

        if (!variantDataEl) return false;
        return this.jsonDecode(variantDataEl.textContent);
    }

    getOptionsData() {
        let optionsDataEl = document.getElementById(
            `${this.productId}-options`
        );

        if (!optionsDataEl) return false;
        return this.jsonDecode(optionsDataEl.textContent);
    }

    getFormElement() {
        return document.getElementById(`${this.productId}-form`);
    }

    getOriginalDestination() {
        let link = this.cardElement.querySelector("a")

        return link.getAttribute("href").split('?')[0] || link.getAttribute("href");
    }

    setOptionsByFilterOptions() {
        try {
            if (this.filterData) {

                for (const option of Object.keys(this.filterData)) {
                    this.selectedOptions[this.filterData[option].position] = this.filterData[option].values[0];
                }

                let foundVariants = this.variantData.filter(variant => {
                    for (const option of Object.keys(this.filterData)) {
                        const optionData = this.filterData[option]

                        const lowerCaseValues = optionData.values.map(function(v) {
                            return v.toLowerCase();
                        });

                        if (!lowerCaseValues.includes(variant[`option${optionData.position}`].toLowerCase())) {
                            return false
                        }

                    }

                    return true
                })


                for (const option of this.optionsData) {
                    const variant = foundVariants[0]
                    if (typeof variant == 'undefined') {
                        return false
                    }

                    if (!Object.keys(this.selectedOptions).includes('' + option.position)) {
                        this.selectedOptions[option.position] = variant[`option${option.position}`]
                        return true
                    }
                }
            }
        } catch (e) {
            console.debug(e)
        }
    }

    selectRadioButtonsForOptions() {
        for (const optionKey in this.selectedOptions) {
            const queryStr = `input[type="radio"][data-option-key="${optionKey}"][value="${this.selectedOptions[optionKey]}" i]`

            const radioElement = this.cardElement.querySelector(queryStr)

            if (radioElement) {
                radioElement.checked = true
            }
        }
    }

    findAndSetInitialVariant() {
        this.selectedVariant = this.getSelectedVariant();

        if (this.selectedVariant) {
            this.selectedVariantId = this.selectedVariant.id;
            this.updateCardDisplay();
        }
    }

    // Event handlers
    attachOpenCloseListeners() {
        this.openElement.addEventListener("click", (e) => {
            e.stopPropagation();
            this.formOpen = true;
            this.closeHideForm();
        });
        this.closeElement.addEventListener("click", (e) => {
            e.stopPropagation();
            this.formOpen = false;
            this.closeHideForm();
        });
    }

    closeHideForm() {
        if (this.formOpen) {
            this.cardElement.classList.add("form-shown");
            this.formElement.setAttribute("aria-hidden", "false");
            this.formElement.style.visibility = "visible";
            this.formElement.setAttribute("tabindex", "0");

            this.formElement.querySelectorAll(".quick-add-option-container__single-option input[type='radio']")[0].focus()
        } else {
            this.cardElement.classList.remove("form-shown");
            this.cardElement.classList.add("slide-up");
            this.formElement.setAttribute("aria-hidden", "true");
            this.formElement.setAttribute("tabindex", "-1");
            setTimeout(() => {
                this.cardElement.classList.remove("slide-up");
                this.formElement.style.visibility = "hidden";
            }, 200);
        }
        window.dispatchEvent(new Event("resize"));
    }

    attachRadioListeners() {
        this.variantElements.forEach((variantElement, index) => {
            this.variantElements[index].addEventListener("change", () =>
                this.radioValueHandler(this.variantElements[index])
            );
        });
    }

    radioValueHandler(variantElement) {

        var debug = true;

        var parentContainer = variantElement.closest('.miir-quick-add-form');

        this.lastSelectedOptionKey =
            variantElement.dataset.optionKey;

        let optionValueEle = this.cardElement.querySelector(
            `.selected-value[data-option-key="${this.lastSelectedOptionKey}"]`
        );

        this.updateSelectedOptions();
        this.filteredVariants = this.getFilteredVariants();

        const variantID = variantElement.dataset.variantId;

        const personalizeButton = parentContainer.querySelector(".button--personalize");

        if (personalizeButton && variantID) {
            personalizeButton.href = `/pages/customize?variant=${variantID}`;
        }

        if (this.filteredVariants.length) {
            this.possibleOptions = this.getPossibleOptions();
            this.hideAllOptionsExceptLast();
            this.hideImpossibleOptions();
        }
        this.selectedVariant = this.getSelectedVariant();

        if (this.selectedVariant) {
            this.selectedVariantId = this.selectedVariant.id;
            this.updateCardDisplay();
        }

        if (optionValueEle) {
            optionValueEle.closest("div").style.display = "block";
            optionValueEle.textContent = variantElement.value;
        }
    }

    attachSubmitHandler() {
        this.getSelectedVariant();
        this.submitElement.addEventListener("click", (e) => {
            e.preventDefault();
            if (this.selectedVariantId) {
                this.addVariantToCart();
            }
        });
    }

    // Managing internal data
    updateSelectedOptions() {
        Array.from(this.variantElements).find((radio) => {
            if (radio.checked) {
                this.selectedOptions[radio.dataset.optionKey] = radio.value;
            }
        });
    }

    getFilteredVariants() {
        return this.variantData.filter((variant) => {
            let optionKeys = Object.keys(this.selectedOptions);

            return optionKeys.some((optionKey) => {
                return (
                    variant[this.optionNamePrefix + optionKey].toLowerCase() ==
                    this.selectedOptions[optionKey].toLowerCase()
                );
            });
        });
    }

    getSelectedVariant() {
        if (this.variantData.length === 1) {
            return this.variantData[0];
        }

        return this.variantData.filter((variant) => {
            let allMatch = Object.keys(this.selectedOptions).every(
                (optionValue) => {
                    return (
                        variant[this.optionNamePrefix + optionValue].toLowerCase() ==
                        this.selectedOptions[optionValue].toLowerCase()
                    );
                }
            );
            return (
                allMatch &&
                Object.keys(this.selectedOptions).length ==
                this.optionsData.length
            );
        })[0];
    }

    getPossibleOptions() {
        this.possibleOptions = this.filteredVariants.map((variant) => {
            let returnData = {};

            this.optionsData.forEach((option) => {
                returnData[option.position] =
                    variant[this.optionNamePrefix + option.position];
            });
            return returnData;
        });
        return this.possibleOptions;
    }

    hideAllOptionsExceptLast() {
        this.variantElements.forEach((radio, index) => {
            if (this.lastSelectedOptionKey == radio.dataset.optionKey) return;

            let relatedLabel = document.querySelector(
                `label[for="${radio.getAttribute("id")}"]`
            );

            if (relatedLabel) {
                radio.setAttribute("disabled", true);
                relatedLabel.style.display = "none";
                relatedLabel.closest(
                    ".quick-add-option-container__single-option"
                ).style.display = "none";
            }
        });
    }

    hideImpossibleOptions() {

        this.variantElements.forEach((radio, index) => {
            if (
                this.possibleOptions.some((possibleOption) => {
                    return (
                        possibleOption[radio.dataset.optionKey] == radio.value
                    );
                })
            ) {
                let relatedLabel = document.querySelector(
                    `label[for="${this.variantElements[index].getAttribute("id")}"]`
                );

                if (relatedLabel) {
                    radio.removeAttribute("disabled");
                    relatedLabel.style.display = "inline-block";
                    relatedLabel.closest(
                        ".quick-add-option-container__single-option"
                    ).style.display = "inline-block";
                }
            }
        });
    }

    isPersonalizerProduct() {
        let isPersonalizerProduct = true;
        let excludedColors = [
            "polished stainless",
            "silver",
            "copper",
            "stainless steel",
            "stainless",
        ];

        for (let selectedOptionKey of Object.keys(this.selectedOptions)) {
            if (
                excludedColors.includes(
                    this.selectedOptions[selectedOptionKey].toLowerCase()
                )
            ) {
                isPersonalizerProduct = false;
            }
        }

        return isPersonalizerProduct;
    }

    // Card management
    updateCardDisplay() {

        var variant = this.selectedVariantId;
        const variantElement = document.querySelector(`[data-variant-id="${variant}"]`);

        console.log("this is the variant: ", variant);


        console.log("this is the variantElement: ", variantElement);

        const parentContainer = variantElement.closest('.miir-quick-add-form');
        const isCustom = variantElement.dataset.variantIscustom === "true";
        const variantID = variantElement.dataset.variantId;

        const personalizeContainer = parentContainer.querySelector(".cdp-button");
        const personalizeButton = parentContainer.querySelector(".button--personalize");
        const orParagraph = parentContainer.querySelector(".quick-add-lower-form-container p");

        console.log("personalize Container: ", personalizeContainer);

        if (!isCustom) {
            personalizeButton.classList.add("hide");
            if (orParagraph) orParagraph.classList.add("hide");
        }

        if(isCustom) {
            personalizeContainer.classList.remove("hide");
            personalizeButton.classList.remove("hide");
            if (orParagraph) orParagraph.classList.remove("hide");
        }

        this.enableAtc();
        this.submitElement.classList.remove(
            "miir-quick-add-form__submit--sold-out"
        );

        if (this.selectedVariant && this.quickAddLink)
            //this.updateQuickAddLink();

        if (
            (!this.selectedVariant.available && this.quickAddLink) ||
            (this.quickAddLink && !this.isPersonalizerProduct())
        )
            this.quickAddLink.setAttribute("href", "");

        if (!this.selectedVariant.available) {
            this.submitElement.classList.add(
                "miir-quick-add-form__submit--sold-out"
            );
            this.disableAtc();
        }

        this.updatePriceDisplay();

        this.updateMedia();
        this.updateLinks();
    }

    enableAtc() {
        this.submitElement.removeAttribute("disabled");
    }

    disableAtc() {
        this.personalizeContainer.classList.add("hide");
        this.submitElement.setAttribute("disabled", "disabled");
    }

    updatePriceDisplay() {
        let priceEle = this.cardElement.querySelector(
            ".miir-quick-add-form__price-display"
        );
        priceEle.textContent = " - " + this.centsToLocale(this.selectedVariant.price);

    }

    updateMedia() {
        let image = this.cardElement.querySelector(
            ".media a > img:nth-child(1)"
        );
        let secondaryImage = this.cardElement.querySelector(
            ".media a > img:nth-child(2)"
        );
        let featuredImageSrc;

        try {
            featuredImageSrc = this.selectedVariant.featured_image.src || false;
        } catch (e) {
            featuredImageSrc = false;
        }

        let mediaContainer = this.cardElement.querySelector(".media");

        if (secondaryImage) secondaryImage.style.display = "none";

        if (featuredImageSrc && mediaContainer) {
            mediaContainer.classList.remove("media--hover-effect");

            image.setAttribute("src", this.selectedVariant.featured_image.src);
            image.setAttribute("srcset", "");
            image.setAttribute("loading", "");
        }
    }

    updateLinks() {
        let links = this.cardElement.querySelectorAll("a");

        for (const link of links) {
            if (link == this.quickAddLink) continue

            link.setAttribute(
                "href",
                this.originalDestination + "?variant=" + this.selectedVariant.id
            );
        }
    }

    updateQuickAddLink() {
        let link =
            this.quickAddLink.dataset.urlPrefix +
            this.selectedVariant.id +
            "&returnurl=" +
            encodeURIComponent(window.location.href) +
            "&sku=" +
            this.selectedVariant.sku +
            "&quantity=1";
        this.quickAddLink.setAttribute("href", link);
    }

    updateMaxQuantity() {
        if (this.selectedVariant.quantity) {
            this.quantityElement.setAttribute(
                "max",
                this.selectedVariant.quantity
            );
        }
    }

    centsToLocale(price) {
        let priceDecimal = price / 100;

        return priceDecimal.toLocaleString("en-US", {
            style: "currency",
            currency: "USD",
        });
    }

    // submitting
    setupCartData() {
        this.formData = {
            id: this.selectedVariantId,
            quantity: 1,
        };
        this.formData.sections_url = window.location.pathname;
    }

    addVariantToCart() {
        this.setupCartData();

        fetch(window.Shopify.routes.root + "cart/add.js", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(this.formData),
        })
            .then((response) => {
                return response.json();
            })
            .then((response) => {
                if (response.status) {
                    return;
                }

                this.cartDrawer.updateCartDisplay(response);
                this.cartDrawer.open(window.accessibilityStrings.cartItemAdded);

                document.dispatchEvent(new Event("postCartAction"));
            })
            .catch((error) => {
                console.error("Error:", error);
            });
    }

    selectDefaults() {
        for (const filterHandle in this.filterData) {
            let filterOption = this.formElement.querySelector(
                `.quick-add-option-container--${filterHandle} input[value="${this.filterData[filterHandle]}"]`
            )

            filterOption.checked = true
        }
    }

    // Misc
    jsonDecode(json) {
        try {
            return JSON.parse(json);
        } catch (e) {
            console.log(e);
            return false;
        }
    }
}

let quickAddForms = [];
let filterData = document.getElementById("collection-filters-data");
let quickAddFormElements = document.querySelectorAll(".miir-quick-add-form");

quickAddFormElements.forEach((quickAddFormElement) => {
    let productId = quickAddFormElement.dataset.productId;

    quickAddForms.push(new QuickAdd(productId));
});
